/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


  // Bundle Product Functionality on Product Page 
function addAllItems(id1){  
  jQuery.post('/cart/add.js', {
    items: [
      {
        quantity: 1,
        id: id1
      }
    ]
  });
  let element = document.getElementById("customAjax");
  element.classList.add("activeLoader");  
    setTimeout(function() { 
        window.location.href = '/cart'; 
    }, 1000);
        
};

// let backToTop = document.getElementById("back_top_top");
// window.onscroll = function() {scrollFunction()};

// function scrollFunction() {
//   if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
//     backToTop.classList.add("show");
//   } else {
//     backToTop.classList.remove("show");
//   }
// }

function myCheckboxFunction(){
  let checkBox = document.getElementsByClassName("upsellCheckbox")[0];
  checkBox.classList.toggle("active");
  let fistBuyButtons = document.getElementById("fistBuyButtons");
  let secondBuyButtons = document.getElementById("secondBuyButtons");
  if (checkBox.classList.contains('active')){
    fistBuyButtons.style.display = "none";
    secondBuyButtons.style.display = "block";
  } else {
    fistBuyButtons.style.display = "block";
    secondBuyButtons.style.display = "none";
  }  
}

function addAllItems(id1,id2){
  const bundleBtn = document.getElementById('AddToCartBundle');
  if (bundleBtn.dataset.soiAdding === 'yes') return;
  bundleBtn.dataset.soiAdding = 'yes';
  bundleBtn.classList.add('active');
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const prefix = root.endsWith('/') ? root : root + '/';
  const drawer = document.getElementById('mini-cart');
  const giftVariant = Number(drawer && drawer.dataset.soiGiftVariantId || 0);
  const isWoodenBox = giftVariant > 0 && Number(id2) === giftVariant;

  // Fetch the existing cart BEFORE assembling a PDP bundle. Otherwise the
  // checkbox can send a second box while Discount Mixer also adds a free one.
  fetch(prefix + 'cart.js', {credentials:'same-origin', cache:'no-store'})
    .then(function(response) { if (!response.ok) throw Error('Cart unavailable'); return response.json(); })
    .catch(function() { return null; })
    .then(function(cart) {
      const items = [{quantity:1,id:id1}];
      const alreadyHasBox = cart && (cart.items || []).some(function(item) {
        return Number(item.variant_id) === Number(id2);
      });
      const mainUnitPrice = Number(bundleBtn.dataset.soiMainPrice || 0);
      const eligibleBefore = cart ? Number(cart.total_price || 0) - (cart.items || []).reduce(function(sum,item) {
        return sum + (Number(item.product_id) === Number(drawer && drawer.dataset.soiGiftProductId) ? Number(item.final_line_price || 0) : 0);
      },0) : 0;
      // When adding this jewelry reaches €350, Discount Mixer should add
      // the free box itself. Sending the box in this PDP request as well is
      // precisely what caused the double gift for a ring + necklace bundle.
      const discountMixerWillQualify = isWoodenBox && mainUnitPrice > 0 && (eligibleBefore + mainUnitPrice >= 35000);
      if (!isWoodenBox || (!alreadyHasBox && !discountMixerWillQualify)) {
        const extra = {quantity:1,id:id2};
        if (isWoodenBox) extra.properties = {_soi_pdp_selected:'yes'};
        items.push(extra);
      }
      return new Promise(function(resolve, reject) {
        jQuery.post(prefix + 'cart/add.js', {items:items}).done(resolve).fail(reject);
      });
    })
    .then(function() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
      if (drawer) drawer.open = true;
    })
    .catch(function(err) {
      console.warn('[SOI PDP] Bundle add failed', err);
      alert('Das Hinzufügen zum Warenkorb hat nicht geklappt. Bitte versuche es erneut.');
    })
    .finally(function() {
      bundleBtn.classList.remove('active');
      bundleBtn.dataset.soiAdding = 'no';
    });
};